module.exports = __webpack_public_path__ + "img/HeroDemos.102d4071.webp";